/* eslint-disable max-len */
import { AllieIconProps } from '../../../components';

export const MetricWarningIcon: React.FC<AllieIconProps> = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.70705 2.1673C9.0131 2.32032 9.26125 2.56848 9.41428 2.87452L13.8327 11.7114C14.2233 12.4926 13.9067 13.4425 13.1255 13.833C12.9059 13.9428 12.6638 14 12.4183 14H3.5814C2.70802 14 2 13.292 2 12.4186C2 12.1731 2.05716 11.931 2.16695 11.7114L6.58538 2.87452C6.97597 2.09335 7.92587 1.77671 8.70705 2.1673ZM8 10C7.44772 10 7 10.4477 7 11C7 11.5523 7.44772 12 8 12C8.55228 12 9 11.5523 9 11C9 10.4477 8.55228 10 8 10ZM8 5C7.48716 5 7.06449 5.38604 7.00673 5.88338L7 6V8C7 8.55228 7.44772 9 8 9C8.51284 9 8.93551 8.61396 8.99327 8.11662L9 8V6C9 5.44772 8.55228 5 8 5Z"
      fill="#F97316"
    />
  </svg>
);
